// removed by extract-text-webpack-plugin
module.exports = {"alert":"alert__3H4x8"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/Alert/styles.scss
// module id = ./app/scripts/views/App/components/Alert/styles.scss
// module chunks = 1